<template>
    <div>
        <b-form-select v-model="form.product" size="sm">
            <b-form-select-option :value="null">สินค้าทั้งหมด</b-form-select-option>
            <b-form-select-option v-for="product in products" :value="product.item_no" :key="product.item_no">
                #{{ product.item_no}} - {{ product.description }}
            </b-form-select-option>
        </b-form-select>

        <line-chart-redemption-monthly :product="form.product"/>
    </div>
</template>

<script>
import LineChartRedemptionMonthly from "./LineChartRedemptionMonthly";

export default {

    components: {
        LineChartRedemptionMonthly
    },

    data: () => ({
        products: [],
        form: {
            product: null
        }
    }),

    async mounted() {
        const { data } = await axios.get('/products')

        this.products = data.data
    }
}
</script>
